'use client';

import { Switch, SubHeader } from '@yanolja-rnd/nol-design-system';

interface SwitchTypeFilterProps {
  onClick: () => void;
  selected: boolean;
  title: string;
}

export const SwitchTypeFilter: React.FC<SwitchTypeFilterProps> = ({ title, selected, onClick }) => {
  const hasSelectedItems = selected;

  return (
    <section className="px-16 py-12">
      <SubHeader.Small
        title={title}
        showDotBadge={hasSelectedItems}
        aside={<Switch checked={selected} onClick={onClick} />}
      />
    </section>
  );
};
